import React from 'react';
import Weapons from '../../../Report/weapons';

export default function WeaponsReport() {
  return <Weapons />;
}
